import { getApiErrorDetail, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { HandlingUnitType } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { createHandlingUnitTypeApi, handlingUnitTypeKeys } from '../api';

export function useArchiveHandlingUnitType(): UseMutationResult<HandlingUnitType, Error, string> {
  const client = useApiClient('admin-auth');
  const api = createHandlingUnitTypeApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<HandlingUnitType, Error, string>({
    mutationFn: (id: string) => api.archiveHandlingUnitType(id),
    onError: (error: Error) => {
      const detail = getApiErrorDetail(error);
      toast.error(detail.message || t('handlingUnitTypes.toast.archiveError'));
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: handlingUnitTypeKeys.lists() });
      toast.success(t('handlingUnitTypes.toast.archived'));
    },
  });
}
